import {
  BookOpen,
  Brain,
  FileText,
  Flag,
  MonitorPlay,
  PenLine,
  RotateCcw,
  Target,
  Timer,
} from "lucide-react";

/* Study Planner task kinds -> real Abhyas features (planner spec §13).
   Shared by StudyPlanner + Dashboard so a task never leads nowhere. */

export const KIND_META = {
  learn: { icon: MonitorPlay, label: "Watch & Learn" },
  revise: { icon: BookOpen, label: "Revision" },
  retrieve: { icon: Brain, label: "Retrieval" },
  practice: { icon: PenLine, label: "5-question practice" },
  review: { icon: RotateCcw, label: "Mistake review" },
  pyq: { icon: FileText, label: "PYQ practice" },
  test: { icon: Timer, label: "Exam Mode" },
  final: { icon: Flag, label: "Final prep" },
  smart: { icon: Target, label: "Smart Practice" }, // legacy plans
};

/** Where a planner task takes the student. Returns {to, state?} or null
    (self-contained revision). */
export const taskAction = (task, me) => {
  const boardKey = me?.board === "CBSE" ? "CBSE" : "CISCE";
  switch (task.kind) {
    case "learn":
      return { to: "/learn/videos" };
    case "practice":
      if (task.chapter) {
        return {
          to: "/practice-setup",
          state: {
            quickStart: {
              board: boardKey,
              klass: String(me?.klass || "10"),
              subject: task.subject,
              chapter: task.chapter,
              difficulty: "Medium",
            },
          },
        };
      }
      return { to: "/practice-setup", state: { subject: task.subject } };
    case "smart":
      return { to: "/smart-practice" };
    case "review":
      return { to: "/reattempt" };
    case "test":
      return { to: "/exam-mode" };
    case "pyq":
      return { to: "/pyq" };
    default:
      return null; // revise / retrieve / final — self-contained
  }
};
